import { retailerEnLang } from "./en-US";
import { retailerArLang } from "./ar-EG";

export const localeEntries = {
  en: retailerEnLang,
  ar: retailerArLang,
};
